import React, { useEffect, useState } from 'react';

const Banner = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [imageUrl, setImageUrl] = useState('');

    useEffect(() => {
        // Function to determine the correct image URL based on screen size
        const updateImage = () => {
            if (window.matchMedia("(max-width: 767px)").matches) {
                // Mobile view
                setImageUrl(process.env.PUBLIC_URL + '/assets/image/group-40941.png');
            } else {
                // Desktop view
                setImageUrl(process.env.PUBLIC_URL + '/assets/image/Hover-Capital.png');
            }
        };

        // Initial image selection
        updateImage();

        // Add a listener to update the image when the screen size changes
        window.addEventListener('resize', updateImage);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', updateImage);
        };
    }, []);

    useEffect(() => {
        if (imageUrl) {
            const img = new Image();
            img.src = imageUrl;
            img.onload = () => {
                setTimeout(() => {
                    setIsLoaded(true);
                }, 300);
            };
        }
    }, [imageUrl]);

    return (
      <section className="banner-section  banner-section-2">
        {imageUrl && <img src={imageUrl} className="banner-background-image2" alt="Banner Background" />}
        <div className="container banner-content-top">
          <div className="row">
            <div className="col-lg-12">
            <div className={`banner-content ${isLoaded ? 'loaded' : ''}`}>
                <div className="banner-heading">
                  <h1>Inspirons <br />
                    les gens <br />
                    à créer de <br />
                    la <span> valeur </span></h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};

export default Banner;
